import * as React  from "react";
import {cx}        from "emotion";

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSearch, faFilePdf} from "@fortawesome/free-solid-svg-icons";

import {is3rdPartyWorkflow} from "@Common/logic/item/is-3rd-party";
import {isPickPack}         from "@Common/logic/item/is-pick-pack";
import {cs}                 from "@Common/react/chain-services";
import {oMapToArr}          from "@Common/utils/objects";
import {upperCaseWord}      from "@Common/utils/strings";
import {Types}              from "@Common/types";

import {ThumbnailPreviewModal} from "../thumbnail-preview-modal/thumbnail-preview-modal";
import {DeliveryStatus}        from "../delivery-status/delivery-status";
import {
    ORDER_ATTRIBUTE_KEY_LABELS
} from "../../approval-route/approval-request-attributes";

import "./kit-card.scss";

const DELIVERY_TYPES_TRACEABLE = ["Mailed", "Shipped"];

export const KitCard = ({component, ...props}) => cs(
    ["deliveryStatus", ({}, next) => DeliveryStatus({next})],
    ["enlargedView", ({}, next) => (
        ThumbnailPreviewModal({renderSibling: next})
    )],
    ({deliveryStatus, enlargedView}) => (
        component?.selections?.quantity > 0 && <div className={cx("kit-card-kc1 kit-card", component.transOrderStatus)} xd-qa-type="card" xd-qa-name={component.itemName}>
            <div className="card-left">
                <div className="thumbnail" xd-qa-type="icon" xd-qa-name="Image Preview"
                onClick={() => enlargedView.show(
                    component?.proofUrls?.jpg ? (
                        component?.proofUrls?.jpg
                    ) : component?.itemThumbnails ? (
                        component?.itemThumbnails.map((thumbnail) => ({"url": thumbnail}))
                    ) : (
                        [{"url": component.thumbnail}]
                    )
                )}>
                    {component?.proofUrls || component?.itemThumbnails || component.thumbnail ? (
                        <img src={getThumbnail(component)} alt={component.itemName}/>
                    ) : (
                        <img src={require("../../../../../../public/assets/NoImageAvailable.png")} alt="No Image Available"/>
                    )}
                </div>
                {component?.proofUrls?.length > 0 || component?.itemThumbnails?.length > 0 && (
                    <div className="card-bottom">
                        <div className="bottom" onClick={() => enlargedView.show(
                            component?.proofUrls?.jpg ? (
                                component?.proofUrls?.jpg
                            ) : component?.itemThumbnails ? (
                                component?.itemThumbnails.map((thumbnail) => ({"url": thumbnail}))
                            ) : (
                                [{"url": component.thumbnail}]
                            )
                        )}>
                            <FontAwesomeIcon key={component.itemId + "faSearch"} className="icon" icon={faSearch} xd-qa-type="icon" xd-qa-name="Search"/>
                            <div className="preview" xd-qa-type="link" xd-qa-name="Preview">Preview</div>
                        </div>
                        <a
                            className="action"
                            target="_blank"
                            href={"/next/web_services/get_production_pdf.php?id_order=" + props.itemId
                            +"&idComponent="+component?.sku?.front
                            +"&is_pending_transaction="+(props.isPendingTransaction?'1':'0')
                            +"&is_approval_email="+(props.isApproval?'1':'0')}
                        >
                        <FontAwesomeIcon className="fa fa-search" icon={faFilePdf} xd-qa-type="icon" xd-qa-name="PDF"/>
                        <div className="text" xd-qa-type="label" xd-qa-name="PDF">
                            {ORDER_ATTRIBUTE_KEY_LABELS['downloadPDF']}
                        </div>
                        </a>
                    </div>
                )}
            </div>
            <div className="card-middle">
                <div className="name" xd-qa-type="label" xd-qa-name="Name" title={component.itemName}>
                    {component.itemName}
                </div>
                <div className="links">

                {component.deliveryStatus && (
                    <div className="link-group">
                        <div className="label">Status</div>
                        {DELIVERY_TYPES_TRACEABLE.includes(component.deliveryStatus) ? (
                                <button
                                    className="link"
                                    xd-qa-type="link"
                                    xd-qa-name="Status"
                                    onClick={async () => deliveryStatus.show({item: component})}
                                >
                                    {component.deliveryStatus}
                                </button>
                            ) : (
                                <div className="value bold" xd-qa-type="label" xd-qa-name="Status">{component.transOrderStatus === "cancelled" ? "Cancelled" : component.deliveryStatus}</div>
                            )
                        }
                    </div>
                )}
                    {component?.proofUrls?.combinedPdf?.length > 0 && (
                        <a
                            href = {component?.proofUrls?.combinedPdf[0].path}
                            download
                            className="link"
                            xd-qa-type="link"
                            xd-qa-name="Download PDF"
                        >
                            Download PDF
                        </a>
                    )}
                    {component.selections.options?.filter(
                        (o) => ((!isPickPack(component) && !is3rdPartyWorkflow(component)) ? o : o?.dev_key !== "paper_type")
                    )?.map((o) => (
                        <div className="link-group">
                            {o &&
                            <>
                                {isJson(o.name) ? (
                                    oMapToArr(JSON.parse(o.name),(value, key:string) => (<>
                                        <div className="label" xd-qa-type="label" xd-qa-name={key}>{key}</div>
                                        <div className="value bold" xd-qa-type="label" xd-qa-name={value}>{value}</div>
                                    </>))
                                ) : (<>
                                    <div
                                        className="label"
                                        xd-qa-type="label"
                                        xd-qa-name={upperCaseWord(o.group)}
                                    >
                                        {upperCaseWord(o.group)}
                                    </div>
                                    <div className="value bold" xd-qa-type="label" xd-qa-name={o.name}>{o.name}</div>
                                </>)}
                            </>
                            }
                        </div>
                    ))}
                </div>
            </div>
            <div className="card-right">
                <div className="top">
                    <div className="quantity">
                        <div className="label">Quantity included in kit</div>
                        <div className="value" xd-qa-type="label" xd-qa-name="Quantity">{component.selections.quantity}</div>
                    </div>
                </div>
            </div>
        </div>
    )
);

const getThumbnail = (component:Types.Apis.Models.KitComponent) => (
    component.itemThumbnails?.[0]
    ?? component.thumbnail
);

const isJson = (string:string) => {
    try {
        JSON.parse(string);
        return true;
    } catch (error) {
        return false;
    }
}

